import ApplicationLocale from '../models/ApplicationLocale';
import enLang from './en-US';

const AppLocale: ApplicationLocale = {
  en: enLang,
};

export default AppLocale;
